import { render, staticRenderFns } from "./PlanSetup.vue?vue&type=template&id=42ebac9a"
import script from "./PlanSetup.vue?vue&type=script&lang=js"
export * from "./PlanSetup.vue?vue&type=script&lang=js"
import style0 from "./PlanSetup.vue?vue&type=style&index=0&id=42ebac9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports